import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { createSelector } from 'reselect';
import Categories from 'ContentUtils/constants/Categories';
import { getSelectedBusinessUnitId } from '../utils/localStorage';
export const getBrandSettings = state => state.resources.brandSettings.brandSettings;
export const getBrandSettingsFetchStatus = state => {
  var _state$resources$bran;
  return (_state$resources$bran = state.resources.brandSettings) === null || _state$resources$bran === void 0 ? void 0 : _state$resources$bran.requestStatus;
};
export const getBrandColors = createSelector([getBrandSettings], brandSettings => brandSettings && brandSettings.colors || []);
export const getBrandColorsFetchStatus = state => {
  return state.resources.brandSettings.colorsRequestStatus;
};
export const getBrandLogos = createSelector([getBrandSettings], brandSettings => brandSettings && brandSettings.logos || []);

/**
 * @deprecated - use getBusinessUnitIdV2 which considers the global BU ID value from localStorage
 */
export const getBusinessUnitId = (state, props) => {
  var _contentSchema$conten, _props$businessUnitId, _state$resources$bran2;
  const {
    contentSchema
  } = state;
  // ensure buid 0 is returned
  if (!isNullOrUndefined(contentSchema === null || contentSchema === void 0 || (_contentSchema$conten = contentSchema.content) === null || _contentSchema$conten === void 0 ? void 0 : _contentSchema$conten.businessUnitId)) {
    return contentSchema.content.businessUnitId;
  }
  return (_props$businessUnitId = props.businessUnitId) !== null && _props$businessUnitId !== void 0 ? _props$businessUnitId : (_state$resources$bran2 = state.resources.brandSettings) === null || _state$resources$bran2 === void 0 ? void 0 : _state$resources$bran2.businessUnitId;
};
export const getBusinessUnitIdV2 = (state, props) => {
  var _contentSchema$conten2, _ref, _props$businessUnitId2, _state$resources$bran3;
  const {
    contentSchema
  } = state;
  if (!isNullOrUndefined(contentSchema === null || contentSchema === void 0 || (_contentSchema$conten2 = contentSchema.content) === null || _contentSchema$conten2 === void 0 ? void 0 : _contentSchema$conten2.businessUnitId)) {
    return contentSchema.content.businessUnitId;
  }
  const buIdFromLocalStorage = getSelectedBusinessUnitId();
  return (_ref = (_props$businessUnitId2 = props.businessUnitId) !== null && _props$businessUnitId2 !== void 0 ? _props$businessUnitId2 : (_state$resources$bran3 = state.resources.brandSettings) === null || _state$resources$bran3 === void 0 ? void 0 : _state$resources$bran3.businessUnitId) !== null && _ref !== void 0 ? _ref :
  /**
   * Checking local storage value last for now (to not override a BU ID from content schema or direct props)
   * Longer term our system could be way simpler if all apps purely checked local storage for BU ID
   */
  buIdFromLocalStorage;
};
export const getBrandKitId = (state, props) => {
  var _state$resources$bran4;
  return (props === null || props === void 0 ? void 0 : props.brandKitId) || ((_state$resources$bran4 = state.resources.brandSettings) === null || _state$resources$bran4 === void 0 ? void 0 : _state$resources$bran4.brandKitId);
};
export const getCategoryNameFromContentSchema = state => {
  var _state$contentSchema;
  return (_state$contentSchema = state.contentSchema) === null || _state$contentSchema === void 0 ? void 0 : _state$contentSchema.categoryName;
};
export const getContentCategoryId = state => {
  var _state$globalContentM;
  return (_state$globalContentM = state.globalContentMeta) === null || _state$globalContentM === void 0 ? void 0 : _state$globalContentM.instanceContentTypeCategoryId;
};
export const getContentCategoryName = createSelector([getCategoryNameFromContentSchema, getContentCategoryId], (categoryName, categoryId) => {
  if (categoryName) {
    return categoryName;
  }
  if (categoryId && Categories[categoryId]) {
    return Categories[categoryId].name;
  }
  return undefined;
});
export const getBrandedLogoValue = state => {
  return state.resources.brandSettings.brandedLogo || {};
};